import _BaseAPIService from "./_BaseAPIService";

  const apiService = _BaseAPIService.instance;
const PrivacyService = {
  getList: async () => {
    const response = await apiService.get("/systemdata",{
      params:{
        page:1,
        pageSize:20,
      }
    });
    return response.data;
  },
  getbyId: async (id) => {
    console.log(id)
    const response = await apiService.get(`/systemdata/${id}`);
    return response.data;
  },
  getbyslug: async (id) => {
    console.log(id)
    const response = await apiService.get(`/systemdata/slug/${id}`);
    return response.data;
  },
    
}

export default PrivacyService
